var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"chart"},[_c('Chart',{attrs:{"id":_vm.id,"extend-data":_vm.extendData,"height":_vm.height,"option":_vm.option,"width":_vm.width}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }